import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import OrganizationList from './screens/organizationList';
import CreateOrganization from './screens/createOrganization';
import HomeHeader from './components/homepageHeader';
import CommonHeader from './components/commonHeader';
import OrganizationDetail from './screens/organizationDetails';
import AddAccount from './screens/createAccount';
import Location from './screens/createLocation';
import Campaign from './screens/createCampaign';
import DeviceList from './screens/deviceList';
import DeviceDetail from './screens/deviceDetails';
import MemberListing from './screens/memberList';
import AddMember from './screens/addMember';
import Header from './screens/Header';
import Login from './screens/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/authContext';
import ScrollToTop from './components/ScrollToTop';

const AppContent = () => {
  const { userData } = useAuth();

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Login Route */}
        <Route
          path="/login"
          element={
            <>
              <Header />
              <Login />
            </>
          }
        />

        {/* Organizations Listing Route (Only for SUPERADMIN) */}
        <Route
          path="/organizations"
          element={
            <ProtectedRoute allowedRoles={['SUPERADMIN']}>
              <>
                <HomeHeader />
                <OrganizationList />
              </>
            </ProtectedRoute>
          }
        />

        {/* Create Organization Route (Only for SUPERADMIN) */}
        <Route
          path="/create-organization"
          element={
            <ProtectedRoute allowedRoles={['SUPERADMIN']}>
              <>
                <HomeHeader />
                <CreateOrganization />
              </>
            </ProtectedRoute>
          }
        />

        {/* Organization Routes */}
        <Route
          path="/organization/:organizationId"
          element={
            <ProtectedRoute allowedRoles={['SUPERADMIN', 'ADMIN']}>
              <>
                <CommonHeader />
                <Outlet /> {/* Nested routes will render here */}
              </>
            </ProtectedRoute>
          }
        >
          {/* Organization Detail */}
          <Route index element={<OrganizationDetail />} />

          {/* Edit Organization */}
          <Route path="edit" element={<CreateOrganization />} />

          {/* Organization Reporting */}
          <Route path="reporting" element={<div>Reporting</div>} />

          {/* Account Routes */}
          <Route path="account/:accountId" element={<Outlet />}>
            {/* Account Detail */}
            <Route index element={<AddAccount />} />

            {/* Edit Account */}
            <Route path="edit" element={<AddAccount />} />
          </Route>

          {/* Campaign Routes */}
          <Route path="campaigns" element={<Outlet />}>
            {/* Campaign List */}
            <Route index element={<Campaign />} />

            {/* Campaign Detail */}
            <Route path=":campaignId" element={<Campaign />} />
          </Route>

          {/* User Routes */}
          <Route path="users" element={<Outlet />}>
            {/* User List */}
            <Route index element={<MemberListing />} />

            {/* Add Member */}
            <Route path="add" element={<AddMember />} />

            {/* Edit Member */}
            <Route path=":userId/edit" element={<AddMember />} />
          </Route>

          {/* Device Routes */}
          <Route path="devices" element={<Outlet />}>
            {/* Device List */}
            <Route index element={<DeviceList />} />

            {/* Device Detail */}
            <Route path=":deviceId" element={<DeviceDetail />} />
          </Route>

          {/* Location Routes */}
          <Route path="locations" element={<Outlet />}>
            {/* Location List */}
            <Route index element={<Location />} />

            {/* Location Detail */}
            <Route path=":locationId" element={<Location />} />
          </Route>
        </Route>

        {/* Default Route (Redirect to Login or Organization Detail) */}
        <Route
          path="*"
          element={
            !userData ? (
              <Navigate to="/login" />
            ) : userData?.role === 'SUPERADMIN' ? (
              <Navigate to="/organizations" />
            ) : (
              <Navigate to={`/organization/${userData?.organizationId}`} />
            )
          }
        />
      </Routes>
    </Router>
  );
};

// Main App Component
function App() {
  useEffect(() => {
    document.title = 'BackpackEMR WebAdmin';
  }, []);

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;